export default __webpack_public_path__ + "static/media/circle-four.dd4cf3ae.svg";